// eslint-disable-next-line no-restricted-imports
import { UserFeedbackConfirmRequestUserFeedbackTypeEnum } from '@eih-netbroker/api-user-feedback';

export const UserFeedbackType = UserFeedbackConfirmRequestUserFeedbackTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type UserFeedbackType = (typeof UserFeedbackType)[keyof typeof UserFeedbackType];
